export default __webpack_public_path__ + "static/media/ic_cart1.0cb6611c.png";